// extracted by mini-css-extract-plugin
export var root = "_zx-0";
export var scroll = "_zx-1";
export var thumb = "_zx-3";
export var track = "_zx-2";